import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _times from "lodash/times";
import _isNumber from "lodash/isNumber";
import './index.scss';
import cx from 'classnames';
import React from 'react';
import Icon from '../Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultProps = {
  extraClass: '',
  size: 18,
  wrapped: false
};
class Rating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredRating: -1
    };
  }
  render() {
    const {
      extraClass,
      onRate,
      rating,
      size,
      wrapped
    } = this.props;
    const {
      hoveredRating
    } = this.state;
    const currentRate = rating != null && _isNumber(rating) ? rating - 1 : hoveredRating;
    return ___EmotionJSX("div", {
      className: cx('le-shared-rating', {
        'rating-wrapped': wrapped
      }, extraClass)
    }, _times(5, index => ___EmotionJSX("button", {
      className: cx({
        'active-rating-star': index <= currentRate
      }),
      key: index,
      onClick: () => onRate(index + 1),
      onMouseEnter: () => {
        this.setState({
          hoveredRating: index
        });
      },
      onMouseLeave: () => {
        this.setState({
          hoveredRating: -1
        });
      },
      type: "button"
    }, ___EmotionJSX(Icon, {
      name: "star",
      size: size
    }))));
  }
}
_defineProperty(Rating, "defaultProps", defaultProps);
export default Rating;